import {CompositionService} from "./services/CompositionService";
import {CompositionEventsEnum} from "./CompositionEvents";
import {CompositionStateStore, Layer} from "./store/CompositionStateStore";

class CompositionBridge {

    private initialized = false;

    init() {
        if (this.initialized) return;
        this.setupEventListeners();
    }

    private setupEventListeners() {
        const composition = CompositionService.composition;
        composition.on(CompositionEventsEnum.LAYER_ADDED, this.handleLayerAdded);
        composition.on(CompositionEventsEnum.CLIP_ADDED, this.handleClipAdded);
        this.initialized = true;
    }

    private handleLayerAdded = (event) => {
        const payload = event.detail;
        console.log("Received layer added event: ", payload);
        const layer = {id: payload.layer.id, clipIds: []}
        CompositionStateStore.addLayer(layer);
    }

    private handleClipAdded = (event) => {
        const payload = event.detail;
        console.log("Received clip added event: ", payload);
        CompositionStateStore.addClip(payload.layerId, payload.clip);
    }
}

export default new CompositionBridge();
